import { TBookmark } from '@/interfaces/collections';
import React from 'react';

interface HeroImageProps {
  heroImages: TBookmark[] | undefined;
}
export default function HeroImage({ heroImages }: HeroImageProps) {
  return (
    <div className="w-[100vw] mx-[-64px] min-w-[1280px] max-w-[2528px] flex gap-[45px] justify-center items-center overflow-x-hidden h-[600px]">
      <div className="w-full h-full">
        {heroImages && heroImages.length > 1 ? (
          <img
            className="object-cover w-full half-oval-clip-left h-full"
            src={heroImages[0].photo?.imgix.links.large_image_url ?? ''}
            alt="hero image"
          />
        ) : (
          <div className="w-full h-full half-oval-clip-left bg-gradient-to-b from-[#D8D8D9] to-[#375C8D]"></div>
        )}
      </div>
      <div className="w-full h-full">
        {heroImages && heroImages.length > 1 ? (
          <img
            className="object-cover w-full half-oval-clip-right h-full"
            src={heroImages[1].photo?.imgix.links.large_image_url ?? ''}
            alt="hero image"
          />
        ) : (
          <div className="w-full h-full bg-red-400 half-oval-clip-right bg-gradient-to-b from-[#375C8D] to-[#D8D8D9]"></div>
        )}
      </div>
    </div>
  );
}
